<script>
import SmoothScroll from "@/assets/smoothscroll.js";

import VIcon from "@/components/atoms/VIcon.vue";
import VPicture from "@/components/atoms/VPicture.vue";
import VMarkdown from "@/components/atoms/VMarkdown.vue";
import VSwiper from "@/components/molecules/VSwiper.vue";
import VToggleOnScroll from "@/components/atoms/VToggleOnScroll.vue";
import VVideo from "@/components/atoms/VVideo.vue";

export default {
  name: "VModule",
  components: {
    VIcon,
    VPicture,
    VMarkdown,
    VSwiper,
    VToggleOnScroll,
    VVideo
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    SmoothScroll.polyfill();
  },
  methods: {
    scrollTo() {
      window.scrollTo({
        top: this.$el.offsetTop + this.$el.offsetHeight,
        behavior: "smooth"
      });
    }
  }
};
</script>

<template>
  <div :class="data.theme ? `theme theme--${data.theme}` : ''" class="module">
    <div class="module__inner">
      <VToggleOnScroll
        v-if="data.title"
        v-html="data.title"
        class="module__title"
      />

      <VToggleOnScroll v-if="data.gallery">
        <VSwiper :data="data.gallery" />
      </VToggleOnScroll>

      <VToggleOnScroll v-if="data.image">
        <VPicture :data="data.image" />
      </VToggleOnScroll>

      <VToggleOnScroll v-if="data.video">
        <VVideo :data="data.video" />
      </VToggleOnScroll>

      <div v-if="data.grid" class="module__grid">
        <VToggleOnScroll
          v-for="(item, index) in data.grid"
          :key="index"
          :delay="index"
          class="module__grid-item"
        >
          <VPicture v-if="item.image" :data="item.image" />
          <VVideo v-if="item.video" :data="item.video" />
          <VMarkdown v-if="item.text" :data="item.text" />
        </VToggleOnScroll>
      </div>
    </div>

    <button @click="scrollTo" class="module__btn-scroll">
      <span class="text">CLIQUER LA FLÈCHE </span>
      <VIcon :data="'arrow-down'" />
    </button>

    <VIcon
      v-if="data.decoration"
      :data="data.decoration"
      :class="`module__decoration--${data.decoration}`"
      class="module__decoration theme-color-accent"
    />
  </div>
</template>
